jQuery(document).ready(function () {


    /**
     * required html for this script to work correctly
     *
     * <div class="form-group country_group col-md-6">
     <div class="">
     <label>الدولة <span>*</span></label>
     <select class="form-control country_select" name="country_id"  id="country_id">
     <option value="" selected disabled>إختر الدولة</option>
     @foreach($countries as $row)
     <option value="{{$row->id}}" data-mobile-code="{{$row->mobile_code}}">{{$row->title}}</option>
     @endforeach
     </select>
     </div>

     </div>
     <div class="form-group city_group col-md-6">
     <div class="">
     <label>المدينة <span>*</span></label>
     <select name="city_id" id="city_id" class="form-control city_select">
     <option value="" selected disabled>إختر المدينة</option>
     </select>
     </div>
     </div>

     *  required classes => country_group, country_select, city_group, city_select
     */



    $(document).on('change', "select.country_select", function () {
        let city_select = selected_city_id = country_id = null;
        consoleLog(city_select);

        city_select = $(this).parents('.country_group').siblings('.city_group').find("select.city_select");
        consoleLog(city_select);

        selected_city_id = $(this).attr('data-selected-city');
        $(this).removeAttr('data-selected-city');
        consoleLog(selected_city_id);

        if (city_select) {

            country_id = $(this).children("option:selected").val();

            if ($(this).val() == 'all') {

                try {

                    city_select.selectpicker('val', 'all');

                } catch (error) {
                    city_select.val('all');
                }


            }
            else if (country_id) {
                $.ajax({
                    type: 'GET',
                    url: '/cities/' + country_id,
                    dataType: 'json',
                    data: { 'id': country_id },
                    success: function (data) {
                        city_select.find('.addedItem').remove();


                        data.forEach(function (row) {

                            city_select.append(`<option class="addedItem" value="${row.id}" >${row.title}</option>`);
                        });

                        var is_city_found = selected_city_id == 'all' || data.find(function (row) {
                            if (row.id == selected_city_id)
                                return true;
                        });

                        try {

                            city_select.selectpicker("refresh");
                        } catch (error) {

                        }

                        if (selected_city_id && is_city_found) {
                            try {
                                if (city_select.attr('multiple')) {
                                    city_select.selectpicker('val', selected_city_id.split(','));
                                } else {
                                    city_select.selectpicker('val', selected_city_id);
                                }
                            } catch (error) {
                                city_select.val(selected_city_id);
                            }

                        } else {
                            city_select.val('');
                        }

                    }

                });

            }

        }

    });


    function setSelectValue(input, value){

        if(input.hasClass('selectpicker')){
            input.selectpicker('val',value);

        }else if(input.hasClass('select2')){
            input.val(value).trigger('change');

        }else{
            input.val(value).trigger('change');
        }
    }
    function handleServerSideCountryCityGroups(){


        /**
         * required html for this script to work correctly
         *
         *
         <div class="form-group ss_country_group col-md-6">
         <div class="">
         <label>الدولة <span>*</span></label>
         <select class="form-control ss_country_select" name="country_id"  id="country_id">
         <option value="" selected disabled>إختر الدولة</option>
         @foreach($countries as $row)
         <option value="{{$row->id}}" data-mobile-code="{{$row->mobile_code}}">{{$row->title}}</option>
         @endforeach
         </select>
         </div>
         </div>

         // can add one or more consequent city groups
         // can be single or multiple => for multiple the name must contain [] (name="city_id" , name="cities_ids[]")
         // set default value as follow (data-default-selected="10", data-default-selected=[1,2,3])
         // if all_cities_option is needed => add this option in the select html <option value="all">كل المدن</option>
         <div class="form-group ss_city_group col-md-6">
         <div class="">
         <label>المدينة <span>*</span></label>
         <select name="city_id" id="city_id" class="form-control ss_city_select"
         multiple=""
         data-default-selected=""
         data-show-selected-list="true" // if multiple
         data-hide-disabled="true" // if all_cities is needed
         data-selected-text-format="count" // if multiple
         >
         <option value="" selected disabled>إختر المدينة</option>  // if all_cities not needed
         <option value="all">كل المدن</option> // if all_cities is needed

         </select>
         </div>
         </div>

         *  required classes => ss_country_group, ss_country_select, ss_city_group, ss_city_select
         */

        $(document).on('change', "select.ss_country_select", function () {
            let ss_city_select = ss_city_select2 = country_id = null;

            // get related city selects for this country select
            let ss_city_selects_list = [];
            let ss_city_group = $(this).closest('.ss_country_group').nextAll('.ss_city_group:first');
            while (ss_city_group){
                ss_city_selects_list.push(ss_city_group.find("select.ss_city_select"));
                let next_el = ss_city_group.next();
                if(next_el.hasClass('ss_city_group')){
                    ss_city_group = next_el;
                }else{
                    ss_city_group = null;
                }
            }

            consoleLog('ss_city_selects_list',ss_city_selects_list);

            if (ss_city_selects_list.length) {

                country_id = $(this).children("option:selected").val();

                if ($(this).val() == 'all') {

                    try {

                        ss_city_selects_list.forEach(function (ss_city_select){
                            ss_city_select.find('.addedItem').remove();
                            setSelectValue(ss_city_select,'all');
                        });
                    } catch (error) {
                    }


                }
                else if (country_id) {

                    $.ajax({
                        type: 'GET',
                        url: '/cities/' + country_id,
                        dataType: 'json',
                        data: { 'id': country_id },
                        success: function (data) {

                            // prepare cities options
                            let cities_options = "";
                            data.forEach(function (row) {
                                cities_options += `<option class="addedItem" value="${row.id}" >${row.title}</option>`
                            });

                            // fill city selects with new options
                            ss_city_selects_list.forEach(function (ss_city_select){
                                ss_city_select.find('.addedItem').remove();
                                ss_city_select.append(cities_options);


                                // set default value
                                let selected_city_id = ss_city_select.attr('data-default-selected');
                                ss_city_select.removeAttr('data-default-selected');
                                consoleLog('selected_city_id',selected_city_id);

                                var found_cities = [];
                                let selected_city_array = [];
                                if(selected_city_id){

                                    selected_city_array = selected_city_id.split(", ");
                                    // consoleLog('selected_city_array',selected_city_array);

                                    if( selected_city_array.includes('all')){
                                        found_cities.push("all");
                                    }else{

                                        selected_city_array.forEach(function(city_id){
                                            let city_found = data.find(function (row){
                                                // consoleLog('row', row, row.id, city_id)
                                                if (row.id == city_id) {
                                                    return true;
                                                }
                                            });
                                            // consoleLog('city_found',city_found)
                                            if(city_found){
                                                found_cities.push(city_id);
                                            }
                                        });
                                    }
                                }


                                consoleLog('found_cities',found_cities, found_cities.toString());
                                try {
                                    ss_city_select.selectpicker("refresh");
                                } catch (error) {

                                }

                                if (found_cities.length) {
                                    try {

                                        setSelectValue(ss_city_select,found_cities);

                                    } catch (error) {
                                    }

                                } else {
                                    setSelectValue(ss_city_select,null)
                                }


                            });


                        }

                    });

                }

            }

        });

        $(document).on('change', "select.ss_city_select", function (){
            let selected = $(this).val();
            let is_multiple = $(this).attr('multiple');
            let is_all_selected = false;
            if(is_multiple){
                is_all_selected = selected.includes('all');
            }else{
                is_all_selected = selected === 'all';
            }

            // hide all options if all_cities is selected
            if(is_all_selected){
                $(this).find('.addedItem').prop('disabled', 'disabled');
                $(this).find('.addedItem').prop('selected', false);
                $(this).val('all');
            }else{
                $(this).find('.addedItem').prop('disabled', false);
            }
            try {
                $(this).selectpicker("refresh");
            } catch (error) {

            }

            //show-selected-list if it has multiple
            if(is_multiple){
                if($(this).attr('data-show-selected-list') === 'true'){
                    consoleLog('selected', selected);
                    let dropdown_btn = $(this).next('.btn.dropdown-toggle');
                    if(dropdown_btn.next().hasClass('ss_city_select_selected_items')){
                        dropdown_btn.next().remove();
                    }
                    let ss_city_select_selected_items = `<div class="ss_city_select_selected_items w-100 mt-2">`;
                    $(this).children("option:selected:not(:disabled)").each(function(){
                        ss_city_select_selected_items+= `<span class="selected_item mx-1 kt-badge kt-badge--outline kt-badge--dark kt-badge--md  kt-badge--inline kt-badge--pill"><i
                    class="fa fa-times-circle mx-1 remove_selected_item_icon" data-val="${$(this).val()}"></i>${$(this).text()}</span>`;
                    });
                    ss_city_select_selected_items+= `</div>`;

                    dropdown_btn.after(ss_city_select_selected_items);
                }
            }

        });

        $(document).on('click', '.remove_selected_item_icon', function (){
            let select = $(this).closest('.ss_city_group').find('select.ss_city_select');
            let val = $(this).attr('data-val');
            consoleLog('remove_selected_item_icon:select', select);
            consoleLog('remove_selected_item_icon:val', val);
            if(select){
                select.find(`[value=${val}]`).prop("selected", false);
                select.selectpicker('refresh');
                select.trigger('change');
            }
            $(this).closest('.selected_item').remove();

        });
    }



    handleServerSideCountryCityGroups();
});


